import { useEffect } from "react";
import AboutUs from "./pages/AboutUs";
import { Header, Footer } from "./components";

import "./App.css";
import "./assets/styles/globals.scss";

function App() {
  useEffect(() => {
    if ("IntersectionObserver" in window === false) {
      const script = document.createElement("script");
      script.src =
        "https://polyfill.io/v3/polyfill.js?features=IntersectionObserver";
      script.async = true;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    return () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    };
  }, []);

  return (
    <>
      <Header />
      <main>
        <AboutUs />
      </main>
      <Footer />
    </>
  );
}

export default App;
